import { setTag } from '@sentry/browser';

import { type UserProfileType } from '@/api/user';

const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1']);

const isLocalhost = () => LOCAL_HOSTNAMES.has(window.location.hostname);

export const isSentryEnabled = () =>
  Boolean(import.meta.env.VITE_SENTRY_DSN) &&
  import.meta.env.VITE_ENVIRONMENT !== 'local' &&
  !import.meta.env.DEV &&
  !isLocalhost();

export const updateSentryTags = (user?: UserProfileType) => {
  if (user) {
    setTag('user_email', user.email);
    setTag('instance_id', user.currentOrg.instanceId);
  }
};
